import clsx from 'clsx'
import isUrlHttp from 'is-url-http'

import { DEFAULT_INFORMATION } from 'utils/constants'

export interface PieImageProps {
	images: any[]
	className?: string
	alt?: string
	defaultImage?: string
}

export function getUrlFromPieImage(src?: string | null, defaultImage = DEFAULT_INFORMATION.pieImageUrl) {
	let url = src
	if (!url) {
		url = defaultImage ?? DEFAULT_INFORMATION.pieImageUrl
	} else {
		if (!isUrlHttp(url) && url.indexOf('data:') === -1 && url.indexOf('blob:') === -1) {
			url = `${import.meta.env.VITE_MEDIA_URL}/${src}`
		}
	}

	return url
}

export function PieImage({ images, defaultImage, alt, className, ...props }: PieImageProps) {
	return images.map((image, index) => (
		<img
			key={index}
			src={getUrlFromPieImage(image, defaultImage)}
			alt={alt}
			className={clsx('object-cover', className)}
			{...props}
		/>
	))
}
